import { styled } from '@mui/system';
import { colorPalette } from '../../colorPalette';
export const StyledDiv = styled('div')(({ margins, variant }) => ({
    background: colorPalette.white,
    boxSizing: 'border-box',
    borderRadius: '5px',
    padding: '17px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: colorPalette.gray800,
    textDecoration: 'none',
    marginTop: (margins === null || margins === void 0 ? void 0 : margins.marginTop) ? `${margins.marginTop}px` : 0,
    marginBottom: (margins === null || margins === void 0 ? void 0 : margins.marginBottom) ? `${margins.marginBottom}px` : 0,
    marginLeft: (margins === null || margins === void 0 ? void 0 : margins.marginLeft) ? `${margins.marginLeft}px` : 0,
    marginRight: (margins === null || margins === void 0 ? void 0 : margins.marginRight) ? `${margins.marginRight}px` : 0,
    border: variant === 'default' ? '1px solid #EBEBEB' : 'none',
    boxShadow: variant === 'shadowed' ? '0 2px 8px #EBEBEB' : 'none',
}));
